export const dataPolicyPath = (language: string, hash = '') => `/data-policy?language=${language}${hash}`
